if (!customElements.get('cart-fraud')) {
  class CartFraud extends HTMLElement {
    constructor() {
      super();
      this.cartFraudCheckbox = this.querySelector('.js-cart-fraud-checkbox');
      this.form = document.getElementById(this.cartFraudCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartFraudCheckbox.checked) {
        evt.preventDefault();
        alert("You must agree to the Wyllo terms and conditions before continuing."); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-fraud', CartFraud);
}

if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}

if (!customElements.get('cart-delivery')) {
  class CartDelivery extends HTMLElement {
    constructor() {
      super();
      this.cartDeliveryCheckbox = this.querySelector('.js-cart-delivery-checkbox');
      this.form = document.getElementById(this.cartDeliveryCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartDeliveryCheckbox.checked) {
        evt.preventDefault();
        alert("You must agree to the Delivery Signature Requirement before continuing."); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-delivery', CartDelivery);
}


if (!customElements.get('cart-taxcollection')) {
  class CartTaxcollection extends HTMLElement {
    constructor() {
      super();
      this.cartTaxcollectionCheckbox = this.querySelector('.js-cart-taxcollection-checkbox');
      this.form = document.getElementById(this.cartTaxcollectionCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTaxcollectionCheckbox.checked) {
        evt.preventDefault();
        alert("You must agree to the Tax Collection Terms before continuing."); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-taxcollection', CartTaxcollection);
}



